export default __webpack_public_path__ + "files/phos_trend_stations_20_years-23ecc9598e75724d6b961ca3d5c4834d.geojson";